/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-unresolved */
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Container, Box, Typography, FormControlLabel, Radio, Card,
} from "@mui/material";
import TextFieldComponent from "components/TextField";
import ButtonComponent from "components/Button";
import RadioButtonFieldComponent from "components/RadioButtonField";
import {
  schema,
  getTextfieldData,
  getRadioButtonData,
  getButtonData,
  getTextfieldDataUPIbased,
  getTextfieldDataSMSbased,
  getCheckboxPayments,
} from "./helper";
import {getCheckboxData2} from "../SellerProductEntryForm/helper";
import CheckboxComponent from "../../../Checkbox";

const PaymentEditor = ({
  setState, payment, updatePaymentCall, cancelEdit,
}) => {
  const { paymentoption, paymentkey, paymentupi } = payment;

  const [participants, setParticipants] = useState(paymentoption);

  const [blur, setblur] = React.useState({
    paymentkey: false,
    paymentupi: false,
    upibased: false,
    codbased: false,
    viagateway: false,
  });

  const onFinish = () => {
    updatePaymentCall({
      paymentoption, paymentkey, paymentupi
    });
  };

  const handleTextFieldChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });
  };

  const handleRadioButtonChange = (event, field) => {
    setState(event.target.value, field);
    setblur({ ...blur, [field]: true });
  };

  const handleCheckBoxListChange = (event, field) => {

    setblur({ ...blur, [field]: true });

    const value = field;
    let newlist = participants;

    newlist = newlist.includes(value) ? newlist.filter((f) => f !== value) : [...newlist, value];
    setParticipants(newlist);
    setState(newlist, "paymentoption");
  };

  const hasError = () => {
    try {
      return !schema.validateSync(payment);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.paymentoption || blur.paymentkey || blur.paymentupi || blur.upibased || blur.codbased || blur.viagateway );

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, payment);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

  const options = [
    { label: "UPI - Direct to shop", value: "upibased" },
    /*
{ label: "CoD (Cash on Delivery) - Direct to shop", value: "codbased" },
{ label: "Pay via Shopana (UPI/Credit Card)", value: "viagateway" },
*/
  ];

  const upibased = paymentoption.includes("upibased");
  const codbased = paymentoption.includes("codbased");
  const viagateway = paymentoption.includes("viagateway");

  const inputOptions = options.map((item) => {
    const { label, value } = item;
    return (
      <FormControlLabel value={value} control={<Radio />} label={label} />
    );
  });

  return (
    <Container>
      <Box>
        <Card>
          {getCheckboxPayments(/*codbased, */ upibased)
              .map((element) => (
                  <Box className="textfield" m={2}>
                    <CheckboxComponent
                        required
                        label={element.label}
                        value={element.value}
                        onChange={(event) => handleCheckBoxListChange(event, element.onChangeField)}
                    />
                  </Box>
              ))}
        {paymentoption && paymentoption.includes("smsbased") && getTextfieldDataSMSbased(paymentkey).map((element) => (
          <Box className="textfield" m={2}>
            <TextFieldComponent
              required
              label={element.label}
              value={element.value}
              error={!!getError(element.onChangeField)}
              helperText={getError(element.onChangeField)}
              onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
            />
          </Box>
        ))}

          {paymentoption && paymentoption.includes("upibased") && getTextfieldDataUPIbased(paymentupi).map((element) => (
              <Box className="textfield" m={2}>
                <TextFieldComponent
                    required
                    label={element.label}
                    value={element.value}
                    error={!!getError(element.onChangeField)}
                    helperText={getError(element.onChangeField)}
                    onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
                />
              </Box>
          ))}
        </Card>
      </Box>
      <br />
      <Typography align="center">
        {getButtonData(onFinish, cancelEdit, hasError, isTouched).map((element) => (
          <ButtonComponent
              sx={{
                m: 2,
              }}
            type={element.type}
            onClick={element.onClick}
            disabled={element.disabled}
            name={element.name}
          />
        ))}
      </Typography>
    </Container>
  );
};

PaymentEditor.propTypes = {
  setState: PropTypes.func.isRequired,
  payment: PropTypes.object.isRequired,
  updateService: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
};

export default PaymentEditor;
